import { ROLES } from "../../base/constant";
import { isJSON } from "../../base/utils";
import * as helper from "../helpers/edit_user_data"

export const checkIfExist = (state: any, item: any) => {
  return state.users?.findIndex((user: any) => user === item);
};

export const getrole = (roleId: any) => {
  return roleId === parseInt(ROLES.AGENT_ROLE_ID)
    ? "Agent"
    : roleId === parseInt(ROLES.SUPERVISOR_ROLE_ID)
      ? "Supervisor"
      : roleId === parseInt(ROLES.OWNER_ROLE_ID)
        ? "Owner"
        : roleId === parseInt(ROLES.SUB_OWNER_ROLE_ID)
          ? "Subowner"
          : roleId === parseInt(ROLES.MEMBER_ROLE_ID)
            ? "Member"
            : "Admin";
};

export const getstatus = (statusvalue: any) => {
  return statusvalue === 0 ? "Inactive" : "Active";
};

export const addSkills = (data: any) => {
  let skills = JSON.parse(data?.addSkill)
  let skillValue: any = skills?.length > 0 ? skills?.map((elem: any) => elem) : [];

  let skillsval: any = [];
  skillValue?.map((skill: any) => {
    skillsval?.push({
      value: skill?.value,
      key: skill?.key,
    });
  });
  return skillsval;
};

export const setToUserData = (data: any) => {
  return {
    userid: data?.UserID,
    name: data?.UserName ? data?.UserName : "-",
    role: getrole(data?.roleid),
    activeStatus: getstatus(data?.active_status),
    ext: data?.ext ? data?.ext : "-",
    emailId: data?.emailId ?? "-",
    directNumber: data?.directNumber && data?.directNumber !== "null" && data?.directNumber !== null ? data?.directNumber : "Not available",
    deskNumber: data?.desk_phone_number && data?.desk_phone_number !== "null" && data?.desk_phone_number !== null ? data?.desk_phone_number : "Not available",
    channelList: {
      sms: data.sms,
      socialMedia: data.socialMedia,
      voice: data.voice,
      email: data.email,
      chat: data.chat,
    },
    routingProfile: {
      value: data.routing_profile_name,
      key: data.routing_profile,
    },
    skill: addSkills(data),
    reportTo: {
      value: data.report_to_name,
      key: data.report_to,
    },
    outBoundCall: data.outBound_call,
    primaryLanguage: isJSON(data?.primaryLanguage) ? JSON.parse(data?.primaryLanguage) : null,
    secondaryLanguage: isJSON(data?.secondaryLanguage) ? JSON.parse(data?.secondaryLanguage) : null,
    inboundCall: data?.inboundCall,
    outboundCampaignCall: data?.outboundCampaignCall,
    callHandling: helper.callHandling(data),

  };
};
export const showErrros = (data: any) => {
  let showError = false;
  if (data?.voice === 0 && data?.chat === 0 && data?.email === 0 && data?.sms === 0 && data?.socialMedia === 0) {
    showError = true;
  } else {
    showError = false;
  }
  return showError;
};
